<template>
    <component v-if="startVersion!==null" :is="startVersion" 
               :enable-ls-token="enableLsToken"
               :shop-info="shopInfo" 
               :filter-info="filterInfo" 
               :slider-data="sliderData" 
               @onShare="onShare"
               @onshowlogin="showLogin" 
               @onlogincallback="onLoginCallback">
    </component>
</template>

<script>
    import AppStartVersion1 from './AppStartV1.vue';
    import AppStartVersion2 from './AppStartV2.vue';
    export default {
        components: {
            AppStartVersion1: AppStartVersion1,
            AppStartVersion2: AppStartVersion2
        },
        props: {
            shopInfo: Object,
            filterInfo: Object,
            sliderData: { type: Array, default: [] },
            enableLsToken: { type: Boolean, default: false }
        },
        computed: {
            startInfo: function () {
                return this.$store.getters.configs.layout;
            }
        },
        data: function () {
            return {
                startVersion: null
            }
        },
        methods: {
            onShare: function () {
                this.$emit("onshare");
            },
            showLogin: function (show) {
                this.$emit("onshowlogin", show);
            },
            onLoginCallback: function (e) {
                this.$emit("onlogincallback",e);
            }
        },
        created: function () {
            var name = "AppStartVersion1";
            if (this.startInfo && this.startInfo !== null) {
                if (this.startInfo.appVersion && this.startInfo.appVersion !== null && this.startInfo.appVersion !== '') {
                    name = this.startInfo.appVersion;
                }
            }
            this.startVersion = name;
            console.log('startVersion', this.startVersion);
        },
        destroyed: function () {

        },
        watch: {
        }
    }
</script>
